import { render, staticRenderFns } from "./Contactinfo.vue?vue&type=template&id=8b246f14&lang=html&"
import script from "./Contactinfo.vue?vue&type=script&lang=js&"
export * from "./Contactinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports